import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as docketActions from '../actions/dockets';
import { fetchingState } from '@constants';

const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map((x) =>
          x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
            ? action.data.results[0]
            : x,
        ),
    ),
  );

const initialState = {
  docketsSearch: { data: [], state: null },
  appealLocations: { data: [], state: null },
  appealLocation: { data: {}, state: null },
  docketTimeSlots: { data: [], state: null },
  allDocketTimeSlots: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case docketActions.SEARCH_DOCKETS[START]:
      return state.setIn(['docketsSearch', 'state'], fetchingState.FETCHING);
    case docketActions.SEARCH_DOCKETS[SUCCESS]: {
      return state
        .setIn(['docketsSearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['docketsSearch', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case docketActions.SEARCH_DOCKETS[ERROR]: {
      return state.setIn(['docketsSearch', 'state'], fetchingState.ERROR);
    }

    case docketActions.CREATE_APPEAL_DOCKET[SUCCESS]:
      return state.setIn(
        ['docketsSearch', 'data'],
        fromJS(
          state
            .getIn(['docketsSearch', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );

    case docketActions.UPDATE_APPEAL_DOCKET[SUCCESS]:
      return state.setIn(
        ['docketsSearch', 'data'],
        fromJS(
          state
            .getIn(['docketsSearch', 'data'])
            .toJS()
            .filter((t) => t.docketID !== action.docketId)
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    case docketActions.DELETE_DOCKET[SUCCESS]:
      return state.setIn(
        ['docketsSearch', 'data'],
        fromJS(
          state
            .getIn(['docketsSearch', 'data'])
            .toJS()
            .filter((t) => t.docketID !== action.docketId),
        ),
      );
    case docketActions.FINALIZE_DOCKET[SUCCESS]:
      return updateStateArrayItem(state, action, 'docketsSearch', 'docketID');

    case docketActions.FETCH_APPEAL_LOCATIONS[START]:
      return state.setIn(['appealLocations', 'state'], fetchingState.FETCHING);
    case docketActions.FETCH_APPEAL_LOCATIONS[SUCCESS]: {
      return state
        .setIn(['appealLocations', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealLocations', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case docketActions.FETCH_APPEAL_LOCATIONS[ERROR]: {
      return state.setIn(['appealLocations', 'state'], fetchingState.ERROR);
    }

    case docketActions.FETCH_APPEAL_LOCATION[START]:
      return state.setIn(['appealLocation', 'state'], fetchingState.FETCHING);
    case docketActions.FETCH_APPEAL_LOCATION[SUCCESS]: {
      return state
        .setIn(['appealLocation', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealLocation', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case docketActions.FETCH_APPEAL_LOCATION[ERROR]: {
      return state.setIn(['appealLocation', 'state'], fetchingState.ERROR);
    }

    case docketActions.INSERT_APPEAL_LOCATION[SUCCESS]: {
      return state.setIn(
        ['appealLocations', 'data'],
        fromJS(
          state
            .getIn(['appealLocations', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case docketActions.UPDATE_APPEAL_LOCATION[SUCCESS]: {
      return updateStateArrayItem(
        state,
        action,
        'appealLocations',
        'locationID',
      );
    }

    case docketActions.DELETE_APPEAL_LOCATION[SUCCESS]: {
      return state.setIn(
        ['appealLocations', 'data'],
        fromJS(
          state
            .getIn(['appealLocations', 'data'])
            .toJS()
            .filter((u) => u.locationID !== action.locationId),
        ),
      );
    }
    case docketActions.INCREASE_DOCKET_CAPACITY[SUCCESS]: {
      let newState = state.getIn(['docketTimeSlots', 'data']).toJS();
      if (
        action.data &&
        action.data.results &&
        action.data.results.length > 0
      ) {
        for (let x = 0; x < newState.length; x++) {
          for (let y = 0; y < action.data.results.length; y++) {
            if (
              action.data.results[y].docketTimeSlotID ===
              newState[x].docketTimeSlotID
            ) {
              newState[x].hearingCapacity =
                action.data.results[y].hearingCapacity;
            }
          }
        }
      }
      return state.setIn(['docketTimeSlots', 'data'], fromJS(newState));
    }
    case docketActions.CHANGE_DOCKET_CAPACITY[SUCCESS]: {
      let newState = state.getIn(['docketTimeSlots', 'data']).toJS();
      if (
        action.data &&
        action.data.results &&
        action.data.results.length > 0
      ) {
        for (let x = 0; x < newState.length; x++) {
          for (let y = 0; y < action.data.results.length; y++) {
            if (
              action.data.results[y].docketTimeSlotID ===
              newState[x].docketTimeSlotID
            ) {
              newState[x].hearingCapacity =
                action.data.results[y].hearingCapacity;
            }
          }
        }
      }
      return state.setIn(['docketTimeSlots', 'data'], fromJS(newState));
    }
    case docketActions.CLOSE_DOCKET[SUCCESS]: {
      let newState = state.getIn(['docketsSearch', 'data']).toJS();
      if (
        action.data &&
        action.data.results &&
        action.data.results.length > 0
      ) {
        for (let x = 0; x < newState.length; x++) {
          for (let y = 0; y < action.data.results.length; y++) {
            if (action.data.results[y].docketID === newState[x].docketID) {
              newState[x] = { ...newState[x], ...action.data.results[y] };
            }
          }
        }
      }
      return state.setIn(['docketsSearch', 'data'], fromJS(newState));
    }
    case docketActions.REOPEN_DOCKET[SUCCESS]: {
      let newState = state.getIn(['docketsSearch', 'data']).toJS();
      if (
        action.data &&
        action.data.results &&
        action.data.results.length > 0
      ) {
        for (let x = 0; x < newState.length; x++) {
          for (let y = 0; y < action.data.results.length; y++) {
            if (action.data.results[y].docketID === newState[x].docketID) {
              newState[x] = { ...newState[x], ...action.data.results[y] };
            }
          }
        }
      }
      return state.setIn(['docketsSearch', 'data'], fromJS(newState));
    }
    case docketActions.MASS_CLOSE_DOCKET[SUCCESS]: {
      let newState = state.getIn(['docketsSearch', 'data']).toJS();
      if (
        action.data &&
        action.data.results &&
        action.data.results.length > 0
      ) {
        for (let x = 0; x < newState.length; x++) {
          for (let y = 0; y < action.data.results.length; y++) {
            if (action.data.results[y].docketID === newState[x].docketID) {
              newState[x] = { ...newState[x], ...action.data.results[y] };
            }
          }
        }
      }
      return state.setIn(['docketsSearch', 'data'], fromJS(newState));
    }
    case docketActions.FETCH_DOCKET_TIME_SLOTS[START]:
      return state.setIn(['docketTimeSlots', 'state'], fetchingState.FETCHING);
    case docketActions.FETCH_DOCKET_TIME_SLOTS[SUCCESS]: {
      return state
        .setIn(['docketTimeSlots', 'state'], fetchingState.LOADED)
        .setIn(
          ['docketTimeSlots', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case docketActions.FETCH_DOCKET_TIME_SLOTS[ERROR]: {
      return state.setIn(['docketTimeSlots', 'state'], fetchingState.ERROR);
    }

    case docketActions.CREATE_DOCKET_TIME_SLOT[SUCCESS]:
      return state.setIn(
        ['docketTimeSlots', 'data'],
        fromJS(
          state
            .getIn(['docketTimeSlots', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );

    case docketActions.DELETE_DOCKET_TIME_SLOT[SUCCESS]:
      return state.setIn(
        ['docketTimeSlots', 'data'],
        fromJS(
          state
            .getIn(['docketTimeSlots', 'data'])
            .toJS()
            .filter((t) => t.docketTimeSlotID !== action.docketTimeslotId),
        ),
      );

    case docketActions.RESET_DOCKET_TIME_SLOT:
    case docketActions.CLEAR_DOCKET_TIME_SLOT[SUCCESS]:
      return state.setIn(['docketTimeSlots', 'data'], fromJS([]));

    case docketActions.SEARCH_APPEAL_DOCKET_TIMESLOTS[START]:
      return state.setIn(
        ['allDocketTimeSlots', 'state'],
        fetchingState.FETCHING,
      );
    case docketActions.SEARCH_APPEAL_DOCKET_TIMESLOTS[SUCCESS]: {
      return state
        .setIn(['allDocketTimeSlots', 'state'], fetchingState.LOADED)
        .setIn(
          ['allDocketTimeSlots', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case docketActions.SEARCH_APPEAL_DOCKET_TIMESLOTS[ERROR]: {
      return state.setIn(['allDocketTimeSlots', 'state'], fetchingState.ERROR);
    }

    case docketActions.RESET_APPEAL_DOCKET_TIMESLOTS: {
      return state.setIn(['allDocketTimeSlots', 'data'], fromJS([]));
    }

    default:
      return state;
  }
};
